if(!customElements.get('auto-pagination')){
    class AutoPagination extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.observer = null;
            this.type = this.dataset.type;
            this.url = this.dataset.url;

            this.initializeObserver();
        }

        disconnectedCallback(){
            if (this.observer) this.observer.disconnect();
        }

        initializeObserver(){
            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if(entry.isIntersecting){
                            this.loadItems();
                        }
                    });
                },
                {
                    root: null,
                    rootMargin: '200px',
                    threshold: 0
                }
            );

            this.observer.observe(this);
        }

        loadItems(){
            // prevent multiple triggers
            if(this.dataset.disabled === 'true') return;

            this.setAttribute('data-disabled', 'true');

            const data = {
                type: `${this.type}`,
                url: `${this.url}`
            }

            PubSub.publish(PubSub.events.onLoadPagination, {
                data: data,
                callback: this.updatePagination()
            });
        }

        updatePagination(){
            return (url) => {
                if(url){
                    this.setAttribute('data-disabled', 'false');
                    this.setAttribute('data-url', `${url}`);
                    this.url = url;
                }
            };
        }
    }

    customElements.define('auto-pagination', AutoPagination);
}